import type { ReactNode } from 'react';

import { cn } from '@simplywallst/ui-core/next';

type Props = {
  value: number | null;
  children: ReactNode;
};

export const PositiveNegativeValue = ({ value, children }: Props) => {
  if (value === null || value === 0) {
    return <span className="text-subtle">{children}</span>;
  }

  return (
    <span className={cn(value > 0 ? 'text-good' : 'text-bad')}>{children}</span>
  );
};
